import { KioskStateType } from "../../KioskReducer";
import { ActionType } from "../../Actions";
import { CONFIGURATION_CHANGE } from "../../Actions/Kiosk/configurationChangeAction";
import { CONFIGURATION_RESET } from "../../Actions/Kiosk/configurationResetAction";
import storeState, { emptyState } from "../../../utils/storeState";
import { storageKeyConfiguration } from "../../../model/StorageKeys";
import { defaultConfiguration } from "../../../model/DefaultConfiguration";

export default function configurationReducer(
  state: KioskStateType,
  action: ActionType
): KioskStateType {
  switch (action.type) {
    case CONFIGURATION_CHANGE:
      storeState(storageKeyConfiguration, action.payload.configuration);
      return {
        ...state,
        configuration: action.payload.configuration,
      };
    case CONFIGURATION_RESET:
      emptyState(storageKeyConfiguration);
      return {
        ...state,
        configuration: { ...defaultConfiguration }
      };
    default:
      return { ...state };
  }
}
